import axios from "axios";
import { SERVER_URL } from "../ServerLink";

const api = axios.create({
    baseURL: SERVER_URL + "/",
});

api.interceptors.request.use((config) => {
    const token = window.localStorage.getItem("accessToken");
    if (token) {
        config.headers.Authorization = "Bearer " + token;
    }
    return config;
});

export default api;
